import type { ExtraRatesStore } from './interfaces'

export const actions = {
  setLoading (this: ExtraRatesStore, payload: ExtraRatesStore['loading']): void {
    this.loading = payload
  },

  setDaysOfWeek (this: ExtraRatesStore, payload: ExtraRatesStore['daysOfWeek']): void {
    this.daysOfWeek = payload
  },

  setSaving (this: ExtraRatesStore, payload: ExtraRatesStore['saving']): void {
    this.saving = payload
  },

  setTabId (this: ExtraRatesStore, payload: ExtraRatesStore['tabId']): void {
    this.tabId = payload
  },

  getSlotsWithEnabledExtraRates (this: ExtraRatesStore, payload: string): boolean {
    const currentDay = this.daysOfWeek.find(item => item.day_of_week === payload)
    if (!currentDay) {
      return false
    }
    return currentDay.slots.some(slot => slot.enable_extra_rates)
  },
}
